export { default } from "@src/Apps/PrismAnova";
